import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import { MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle } from "@angular/material/expansion";
import { MatIcon } from "@angular/material/icon";
import { TranslocoPipe } from "@jsverse/transloco";

@Component({
    selector: 'loren-faq-section',
    templateUrl: './faq-section.html',
    styleUrls: ['./faq-section.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        MatExpansionPanel,
        MatExpansionPanelHeader,
        MatExpansionPanelTitle,
        MatIcon,
        TranslocoPipe
    ]
})
export class FaqSection {
    @Input() faqTitle: string;
    @Input() faqAnswer: string;
}
